// extracted by mini-css-extract-plugin
export default {"root":"SearchFiltersPrimary_root__bKjWw","filters":"SearchFiltersPrimary_filters__wCzek"};